import { Link } from 'react-router-dom';
import { CONTACT } from '../data/contact.js';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <p className="footer-brand">
          © {year} {CONTACT.business}
        </p>
        <p className="footer-contact">
          <a href={`tel:${CONTACT.phoneTel}`}>{CONTACT.phoneDisplay}</a>
          <span aria-hidden="true"> · </span>
          <a href={CONTACT.facebookUrl} target="_blank" rel="noopener noreferrer">
            Facebook
          </a>
          <span aria-hidden="true"> · </span>
          <span className="footer-tagline">Free quotes · booking services</span>
        </p>
        <p className="footer-legal">
          <Link to="/privacy">Privacy Policy</Link>
          <span aria-hidden="true"> · </span>
          <Link to="/terms">Terms of Service</Link>
        </p>
        <p className="footer-watermark">
          Made by{' '}
          <a href="https://shawnymedia.org" target="_blank" rel="noopener noreferrer">
            ShawnyMedia
          </a>
        </p>
      </div>
    </footer>
  );
}
